exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tips{position:fixed;top:0;left:0;width:100%;height:9.33333vmin;line-height:9.33333vmin;text-align:center;background:#f78989;color:#fff!important;font-size:3.73333vmin;z-index:5}.tips img{width:5.33333vmin;height:5.33333vmin;vertical-align:middle}.tips img,.tips svg{margin-right:1.33333vmin}.tips svg{vertical-align:-.8vmin;font-size:4.26667vmin}.tips span{vertical-align:0}.tips-enter-active,.tips-leave-active{-webkit-transition:all .5s;transition:all .5s}.tips-enter,.tips-leave-active{opacity:0;-webkit-transform:translate3d(0,-100%,0);transform:translate3d(0,-100%,0)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c515611","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Tips.vue
// module id = QWZs
// module chunks = 76